<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'index',
  methods: {
    toModule() {
      if (this.$router.currentRoute.path === '/qc/serviceManage') {
        if (this.$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102100')) {
          this.$router.push('/qc/serviceManage/semanticManagement')
        } else if (this.$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102200')) {
          this.$router.push('/qc/serviceManage/behaviorSettings')
        }
      }
    }
  },
  mounted() {
    this.toModule()
  },
  watch: {
    $route: function (to, from) {
      this.toModule()
    }
  }
}
</script>

<style scoped>

</style>
